
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $abbe51771f551028$exports = {};
/* PrismJS 1.29.0
https://prismjs.com/download.html#themes=prism&languages=markup&plugins=toolbar+copy-to-clipboard */ var $abbe51771f551028$var$_self = "undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {}, $abbe51771f551028$var$Prism = function(e) {
    var n = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, t = 0, r = {}, a = {
        manual: e.Prism && e.Prism.manual,
        disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
        util: {
            encode: function e(n) {
                return n instanceof i ? new i(n.type, e(n.content), n.alias) : Array.isArray(n) ? n.map(e) : n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            type: function(e) {
                return Object.prototype.toString.call(e).slice(8, -1);
            },
            objId: function(e) {
                return e.__id || Object.defineProperty(e, "__id", {
                    value: ++t
                }), e.__id;
            },
            clone: function e(n, t) {
                var r, i;
                switch(t = t || {}, a.util.type(n)){
                    case "Object":
                        if (i = a.util.objId(n), t[i]) return t[i];
                        for(var l in r = {}, t[i] = r, n)n.hasOwnProperty(l) && (r[l] = e(n[l], t));
                        return r;
                    case "Array":
                        return i = a.util.objId(n), t[i] ? t[i] : (r = [], t[i] = r, n.forEach(function(n, a) {
                            r[a] = e(n, t);
                        }), r);
                    default:
                        return n;
                }
            },
            getLanguage: function(e) {
                for(; e;){
                    var t = n.exec(e.className);
                    if (t) return t[1].toLowerCase();
                    e = e.parentElement;
                }
                return "none";
            },
            setLanguage: function(e, t) {
                e.className = e.className.replace(RegExp(n, "gi"), ""), e.classList.add("language-" + t);
            },
            currentScript: function() {
                if ("undefined" == typeof document) return null;
                if ("currentScript" in document) return document.currentScript;
                try {
                    throw new Error;
                } catch (r) {
                    var e = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r.stack) || [])[1];
                    if (e) {
                        var n = document.getElementsByTagName("script");
                        for(var t in n)if (n[t].src == e) return n[t];
                    }
                    return null;
                }
            },
            isActive: function(e, n, t) {
                for(var r = "no-" + n; e;){
                    var a = e.classList;
                    if (a.contains(n)) return !0;
                    if (a.contains(r)) return !1;
                    e = e.parentElement;
                }
                return !!t;
            }
        },
        languages: {
            plain: r,
            plaintext: r,
            text: r,
            txt: r,
            extend: function(e, n) {
                var t = a.util.clone(a.languages[e]);
                for(var r in n)t[r] = n[r];
                return t;
            },
            insertBefore: function(e, n, t, r) {
                var i = (r = r || a.languages)[e], l = {};
                for(var o in i)if (i.hasOwnProperty(o)) {
                    if (o == n) for(var s in t)t.hasOwnProperty(s) && (l[s] = t[s]);
                    t.hasOwnProperty(o) || (l[o] = i[o]);
                }
                var u = r[e];
                return r[e] = l, a.languages.DFS(a.languages, function(n, t) {
                    t === u && n != e && (this[n] = l);
                }), l;
            },
            DFS: function e(n, t, r, i) {
                i = i || {};
                var l = a.util.objId;
                for(var o in n)if (n.hasOwnProperty(o)) {
                    t.call(n, o, n[o], r || o);
                    var s = n[o], u = a.util.type(s);
                    "Object" !== u || i[l(s)] ? "Array" !== u || i[l(s)] || (i[l(s)] = !0, e(s, t, o, i)) : (i[l(s)] = !0, e(s, t, null, i));
                }
            }
        },
        plugins: {},
        highlightAll: function(e, n) {
            a.highlightAllUnder(document, e, n);
        },
        highlightAllUnder: function(e, n, t) {
            var r = {
                callback: t,
                container: e,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            a.hooks.run("before-highlightall", r), r.elements = Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)), a.hooks.run("before-all-elements-highlight", r);
            for(var i, l = 0; i = r.elements[l++];)a.highlightElement(i, !0 === n, r.callback);
        },
        highlightElement: function(n, t, r) {
            var i = a.util.getLanguage(n), l = a.languages[i];
            a.util.setLanguage(n, i);
            var o = n.parentElement;
            o && "pre" === o.nodeName.toLowerCase() && a.util.setLanguage(o, i);
            var s = {
                element: n,
                language: i,
                grammar: l,
                code: n.textContent
            };
            function u(e) {
                s.highlightedCode = e, a.hooks.run("before-insert", s), s.element.innerHTML = s.highlightedCode, a.hooks.run("after-highlight", s), a.hooks.run("complete", s), r && r.call(s.element);
            }
            if (a.hooks.run("before-sanity-check", s), (o = s.element.parentElement) && "pre" === o.nodeName.toLowerCase() && !o.hasAttribute("tabindex") && o.setAttribute("tabindex", "0"), !s.code) return a.hooks.run("complete", s), void (r && r.call(s.element));
            if (a.hooks.run("before-highlight", s), s.grammar) {
                if (t && e.Worker) {
                    var c = new Worker(a.filename);
                    c.onmessage = function(e) {
                        u(e.data);
                    }, c.postMessage(JSON.stringify({
                        language: s.language,
                        code: s.code,
                        immediateClose: !0
                    }));
                } else u(a.highlight(s.code, s.grammar, s.language));
            } else u(a.util.encode(s.code));
        },
        highlight: function(e, n, t) {
            var r = {
                code: e,
                grammar: n,
                language: t
            };
            if (a.hooks.run("before-tokenize", r), !r.grammar) throw new Error('The language "' + r.language + '" has no grammar.');
            return r.tokens = a.tokenize(r.code, r.grammar), a.hooks.run("after-tokenize", r), i.stringify(a.util.encode(r.tokens), r.language);
        },
        tokenize: function(e, n) {
            var t = n.rest;
            if (t) {
                for(var r in t)n[r] = t[r];
                delete n.rest;
            }
            var a = new s;
            return u(a, a.head, e), o(e, a, n, a.head, 0), function(e) {
                for(var n = [], t = e.head.next; t !== e.tail;)n.push(t.value), t = t.next;
                return n;
            }(a);
        },
        hooks: {
            all: {},
            add: function(e, n) {
                var t = a.hooks.all;
                t[e] = t[e] || [], t[e].push(n);
            },
            run: function(e, n) {
                var t = a.hooks.all[e];
                if (t && t.length) for(var r, i = 0; r = t[i++];)r(n);
            }
        },
        Token: i
    };
    function i(e, n, t, r) {
        this.type = e, this.content = n, this.alias = t, this.length = 0 | (r || "").length;
    }
    function l(e, n, t, r) {
        e.lastIndex = n;
        var a = e.exec(t);
        if (a && r && a[1]) {
            var i = a[1].length;
            a.index += i, a[0] = a[0].slice(i);
        }
        return a;
    }
    function o(e, n, t, r, s, g) {
        for(var f in t)if (t.hasOwnProperty(f) && t[f]) {
            var h = t[f];
            h = Array.isArray(h) ? h : [
                h
            ];
            for(var d = 0; d < h.length; ++d){
                if (g && g.cause == f + "," + d) return;
                var v = h[d], p = v.inside, m = !!v.lookbehind, y = !!v.greedy, k = v.alias;
                if (y && !v.pattern.global) {
                    var x = v.pattern.toString().match(/[imsuy]*$/)[0];
                    v.pattern = RegExp(v.pattern.source, x + "g");
                }
                for(var b = v.pattern || v, w = r.next, A = s; w !== n.tail && !(g && A >= g.reach); A += w.value.length, w = w.next){
                    var E = w.value;
                    if (n.length > e.length) return;
                    if (!(E instanceof i)) {
                        var P, L = 1;
                        if (y) {
                            if (!(P = l(b, A, e, m)) || P.index >= e.length) break;
                            var S = P.index, O = P.index + P[0].length, j = A;
                            for(j += w.value.length; S >= j;)j += (w = w.next).value.length;
                            if (A = j -= w.value.length, w.value instanceof i) continue;
                            for(var C = w; C !== n.tail && (j < O || "string" == typeof C.value); C = C.next)L++, j += C.value.length;
                            L--, E = e.slice(A, j), P.index -= A;
                        } else if (!(P = l(b, 0, E, m))) continue;
                        S = P.index;
                        var N = P[0], _ = E.slice(0, S), M = E.slice(S + N.length), W = A + E.length;
                        g && W > g.reach && (g.reach = W);
                        var z = w.prev;
                        if (_ && (z = u(n, z, _), A += _.length), c(n, z, L), w = u(n, z, new i(f, p ? a.tokenize(N, p) : N, k, N)), M && u(n, w, M), L > 1) {
                            var I = {
                                cause: f + "," + d,
                                reach: W
                            };
                            o(e, n, t, w.prev, A, I), g && I.reach > g.reach && (g.reach = I.reach);
                        }
                    }
                }
            }
        }
    }
    function s() {
        var e = {
            value: null,
            prev: null,
            next: null
        }, n = {
            value: null,
            prev: e,
            next: null
        };
        e.next = n, this.head = e, this.tail = n, this.length = 0;
    }
    function u(e, n, t) {
        var r = n.next, a = {
            value: t,
            prev: n,
            next: r
        };
        return n.next = a, r.prev = a, e.length++, a;
    }
    function c(e, n, t) {
        for(var r = n.next, a = 0; a < t && r !== e.tail; a++)r = r.next;
        n.next = r, r.prev = n, e.length -= a;
    }
    if (e.Prism = a, i.stringify = function e(n, t) {
        if ("string" == typeof n) return n;
        if (Array.isArray(n)) {
            var r = "";
            return n.forEach(function(n) {
                r += e(n, t);
            }), r;
        }
        var i = {
            type: n.type,
            content: e(n.content, t),
            tag: "span",
            classes: [
                "token",
                n.type
            ],
            attributes: {},
            language: t
        }, l = n.alias;
        l && (Array.isArray(l) ? Array.prototype.push.apply(i.classes, l) : i.classes.push(l)), a.hooks.run("wrap", i);
        var o = "";
        for(var s in i.attributes)o += " " + s + '="' + (i.attributes[s] || "").replace(/"/g, "&quot;") + '"';
        return "<" + i.tag + ' class="' + i.classes.join(" ") + '"' + o + ">" + i.content + "</" + i.tag + ">";
    }, !e.document) return e.addEventListener ? (a.disableWorkerMessageHandler || e.addEventListener("message", function(n) {
        var t = JSON.parse(n.data), r = t.language, i = t.code, l = t.immediateClose;
        e.postMessage(a.highlight(i, a.languages[r], r)), l && e.close();
    }, !1), a) : a;
    var g = a.util.currentScript();
    function f() {
        a.manual || a.highlightAll();
    }
    if (g && (a.filename = g.src, g.hasAttribute("data-manual") && (a.manual = !0)), !a.manual) {
        var h = document.readyState;
        "loading" === h || "interactive" === h && g && g.defer ? document.addEventListener("DOMContentLoaded", f) : window.requestAnimationFrame ? window.requestAnimationFrame(f) : window.setTimeout(f, 16);
    }
    return a;
}($abbe51771f551028$var$_self);
$abbe51771f551028$exports && ($abbe51771f551028$exports = $abbe51771f551028$var$Prism), "undefined" != typeof $parcel$global && ($parcel$global.Prism = $abbe51771f551028$var$Prism);
$abbe51771f551028$var$Prism.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: !0,
                greedy: !0,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: !0
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: !0
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $abbe51771f551028$var$Prism.languages.markup.tag.inside["attr-value"].inside.entity = $abbe51771f551028$var$Prism.languages.markup.entity, $abbe51771f551028$var$Prism.languages.markup.doctype.inside["internal-subset"].inside = $abbe51771f551028$var$Prism.languages.markup, $abbe51771f551028$var$Prism.hooks.add("wrap", function(a) {
    "entity" === a.type && (a.attributes.title = a.content.replace(/&amp;/, "&"));
}), Object.defineProperty($abbe51771f551028$var$Prism.languages.markup.tag, "addInlined", {
    value: function(a, e) {
        var s = {};
        s["language-" + e] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: !0,
            inside: $abbe51771f551028$var$Prism.languages[e]
        }, s.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var t = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: s
            }
        };
        t["language-" + e] = {
            pattern: /[\s\S]+/,
            inside: $abbe51771f551028$var$Prism.languages[e]
        };
        var n = {};
        n[a] = {
            pattern: RegExp("(<__[^>]*>)(?:<!\\[CDATA\\[(?:[^\\]]|\\](?!\\]>))*\\]\\]>|(?!<!\\[CDATA\\[)[^])*?(?=</__>)".replace(/__/g, function() {
                return a;
            }), "i"),
            lookbehind: !0,
            greedy: !0,
            inside: t
        }, $abbe51771f551028$var$Prism.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($abbe51771f551028$var$Prism.languages.markup.tag, "addAttribute", {
    value: function(a, e) {
        $abbe51771f551028$var$Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp("(^|[\"'\\s])(?:" + a + ")\\s*=\\s*(?:\"[^\"]*\"|'[^']*'|[^\\s'\">=]+(?=[\\s>]))", "i"),
            lookbehind: !0,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: !0,
                            alias: [
                                e,
                                "language-" + e
                            ],
                            inside: $abbe51771f551028$var$Prism.languages[e]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $abbe51771f551028$var$Prism.languages.html = $abbe51771f551028$var$Prism.languages.markup, $abbe51771f551028$var$Prism.languages.mathml = $abbe51771f551028$var$Prism.languages.markup, $abbe51771f551028$var$Prism.languages.svg = $abbe51771f551028$var$Prism.languages.markup, $abbe51771f551028$var$Prism.languages.xml = $abbe51771f551028$var$Prism.languages.extend("markup", {}), $abbe51771f551028$var$Prism.languages.ssml = $abbe51771f551028$var$Prism.languages.xml, $abbe51771f551028$var$Prism.languages.atom = $abbe51771f551028$var$Prism.languages.xml, $abbe51771f551028$var$Prism.languages.rss = $abbe51771f551028$var$Prism.languages.xml;
!function() {
    if ("undefined" != typeof $abbe51771f551028$var$Prism && "undefined" != typeof document) {
        var e = [], t = {}, n = function() {};
        $abbe51771f551028$var$Prism.plugins.toolbar = {};
        var a = $abbe51771f551028$var$Prism.plugins.toolbar.registerButton = function(n, a) {
            var r;
            r = "function" == typeof a ? a : function(e) {
                var t;
                return "function" == typeof a.onClick ? ((t = document.createElement("button")).type = "button", t.addEventListener("click", function() {
                    a.onClick.call(this, e);
                })) : "string" == typeof a.url ? (t = document.createElement("a")).href = a.url : t = document.createElement("span"), a.className && t.classList.add(a.className), t.textContent = a.text, t;
            }, n in t ? console.warn('There is a button with the key "' + n + '" registered already.') : e.push(t[n] = r);
        }, r = $abbe51771f551028$var$Prism.plugins.toolbar.hook = function(a) {
            var r = a.element.parentNode;
            if (r && /pre/i.test(r.nodeName) && !r.parentNode.classList.contains("code-toolbar")) {
                var o = document.createElement("div");
                o.classList.add("code-toolbar"), r.parentNode.insertBefore(o, r), o.appendChild(r);
                var i = document.createElement("div");
                i.classList.add("toolbar");
                var l = e, d = function(e) {
                    for(; e;){
                        var t = e.getAttribute("data-toolbar-order");
                        if (null != t) return (t = t.trim()).length ? t.split(/\s*,\s*/g) : [];
                        e = e.parentElement;
                    }
                }(a.element);
                d && (l = d.map(function(e) {
                    return t[e] || n;
                })), l.forEach(function(e) {
                    var t = e(a);
                    if (t) {
                        var n = document.createElement("div");
                        n.classList.add("toolbar-item"), n.appendChild(t), i.appendChild(n);
                    }
                }), o.appendChild(i);
            }
        };
        a("label", function(e) {
            var t = e.element.parentNode;
            if (t && /pre/i.test(t.nodeName) && t.hasAttribute("data-label")) {
                var n, a, r = t.getAttribute("data-label");
                try {
                    a = document.querySelector("template#" + r);
                } catch (e) {}
                return a ? n = a.content : (t.hasAttribute("data-url") ? (n = document.createElement("a")).href = t.getAttribute("data-url") : n = document.createElement("span"), n.textContent = r), n;
            }
        }), $abbe51771f551028$var$Prism.hooks.add("complete", r);
    }
}();
!function() {
    function t(t) {
        var e = document.createElement("textarea");
        e.value = t.getText(), e.style.top = "0", e.style.left = "0", e.style.position = "fixed", document.body.appendChild(e), e.focus(), e.select();
        try {
            var o = document.execCommand("copy");
            setTimeout(function() {
                o ? t.success() : t.error();
            }, 1);
        } catch (e) {
            setTimeout(function() {
                t.error(e);
            }, 1);
        }
        document.body.removeChild(e);
    }
    "undefined" != typeof $abbe51771f551028$var$Prism && "undefined" != typeof document && ($abbe51771f551028$var$Prism.plugins.toolbar ? $abbe51771f551028$var$Prism.plugins.toolbar.registerButton("copy-to-clipboard", function(e) {
        var o = e.element, n = function(t) {
            var e = {
                copy: "Copy",
                "copy-error": "Press Ctrl+C to copy",
                "copy-success": "Copied!",
                "copy-timeout": 5e3
            };
            for(var o in e){
                for(var n = "data-prismjs-" + o, c = t; c && !c.hasAttribute(n);)c = c.parentElement;
                c && (e[o] = c.getAttribute(n));
            }
            return e;
        }(o), c = document.createElement("button");
        c.className = "copy-to-clipboard-button", c.setAttribute("type", "button");
        var r = document.createElement("span");
        return c.appendChild(r), u("copy"), function(e, o) {
            e.addEventListener("click", function() {
                !function(e) {
                    navigator.clipboard ? navigator.clipboard.writeText(e.getText()).then(e.success, function() {
                        t(e);
                    }) : t(e);
                }(o);
            });
        }(c, {
            getText: function() {
                return o.textContent;
            },
            success: function() {
                u("copy-success"), i();
            },
            error: function() {
                u("copy-error"), setTimeout(function() {
                    !function(t) {
                        window.getSelection().selectAllChildren(t);
                    }(o);
                }, 1), i();
            }
        }), c;
        function i() {
            setTimeout(function() {
                u("copy");
            }, n["copy-timeout"]);
        }
        function u(t) {
            r.textContent = n[t], c.setAttribute("data-copy-state", t);
        }
    }) : console.warn("Copy to Clipboard plugin loaded before Toolbar plugin."));
}();


//# sourceMappingURL=bookable_com.227c616c.js.map
